import { IGetNovosNegociosByIdUseCase } from "../../../presentation/useCases/read/get_novos_negocios_by_id_use_case";
import { NovosNegocios } from "../../models/novos_negocios";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * GetNovosNegociosByIdUseCase
 */

export class GetNovosNegociosByIdUseCase implements IGetNovosNegociosByIdUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idNovosNegocios: number): Promise<NovosNegocios> {
    return this.repository.getNovosNegociosById(idNovosNegocios);

  }
}
